module.exports = __webpack_public_path__ + "static/img/3.dc8ad3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feedbacks/3.jpg
// module id = xthu
// module chunks = 0